<section class="paraImage3">
  <div class="fundo">
      <h2><label>04</label> Meus cursos</h2>
      <div class="container">
        <h3>Formações Concluidas</h3>
          <div class="work" >
            <ng-container *ngFor="let item of formacao" >
              <a href="{{item.link}}" placement="top" ngbTooltip="Visualizar certificado"  target="_blank"  >
                <div class="card">
                  <fa-icon [icon]="faLaptopCode" class="lni-cake"></fa-icon>
                  <p>{{item.name}}</p>
                </div>
              </a>
            </ng-container>
          </div>
      </div>
      <div class="container">
        <h3>Cursos UX <fa-icon [icon]="faSketch" class="lni-cake"></fa-icon> <fa-icon [icon]="faFigma" class="lni-cake"></fa-icon> </h3>
          <div class="workUx" >
            <ng-container *ngFor="let item of cursosUx">
              <a href="{{item.link}}" placement="top" ngbTooltip="Visualizar certificado" target="_blank"  >
                <div class="cardUx">
                  <fa-icon [icon]="faLaptopCode" class="lni-cake"></fa-icon>
                  <p>{{item.name}}</p>
                </div>
              </a>
            </ng-container>
          </div>
      </div>
      <div class="container">
          <h3>Cursos Front End 
              <fa-icon [icon]="faHtml5" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faCss3Alt" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faJsSquare" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faReact" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faAngular" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faGithub" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faNpm" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faSass" class="lni-cake"></fa-icon> 
              <fa-icon [icon]="faBootstrap" class="lni-cake"></fa-icon> 
          </h3>
            <div class="workFront" >
              <ng-container *ngFor="let item of cursosDesenv">
                <a href="{{item.link}}" placement="top" ngbTooltip="Visualizar certificado" target="_blank"  >
                  <div class="cardFront">
                    <fa-icon [icon]="faLaptopCode" class="lni-cake"></fa-icon>
                    <p>{{item.name}}</p>
                  </div>
                </a>
              </ng-container>
            </div>
        </div>
        <div class="container">
          <h3>Cursos Extras </h3>
          <div class="workCurses" >
            <div *ngFor="let item of moreCurses">
              <a href="{{item.link}}" placement="top" ngbTooltip="Visualizar certificado" target="_blank" class="cardCurses">
                <fa-icon [icon]="faLaptopCode" class="lni-cake"></fa-icon>
                <p>{{item.name}}</p>
              </a>
            </div>
          </div>
        </div>
        <div class="container">
          <h3>Graduação</h3>
          <div class="workGraduation" >
            <div *ngFor="let item of graduacao">
              <a href="{{item.link}}" placement="right" ngbTooltip="Visualizar certificado" target="_blank"  class="cardGraduation">
                <fa-icon [icon]="faGraduationCap" class="lni-cake"></fa-icon>
                <p>{{item.name}}</p>
              </a>
            </div>
          </div>
        </div>
        <div class="container">
          <h3>Curriculo PDF</h3>
          <div class="workGraduation" >
            <div *ngFor="let item of curriculo">
              <a href="{{item.link}}" placement="right" ngbTooltip="Visualizar currículo" target="_blank"  class="cardGraduation">
                <fa-icon [icon]="faFilePdf" class="lni-cake"></fa-icon>
                <p>{{item.name}}</p>
              </a>
            </div>
          </div>
        </div>
  </div>
</section>
